import usePermissionContext from "../../hooks/usePermissionContext";
import useAuthContext from "../../hooks/useAuthContext";

export default function PermissionContextFunctions() {
  const { permissions } = usePermissionContext();
  const { role } = useAuthContext();

  const functions = {
    grantPermission: (requiredPermissions) => {
      if (role?.role == "superadmin") return true;

      if (Array.isArray(requiredPermissions)) {
        return requiredPermissions?.some((perm) => {
          return permissions?.UMS
            ? permissions?.UMS?.includes(perm)
            : permissions?.[perm]
            ? permissions?.[perm]
            : false;
        });
      }

      return permissions?.UMS
        ? permissions?.UMS?.includes(requiredPermissions)
        : permissions?.[requiredPermissions]
        ? permissions?.[requiredPermissions]
        : false;
    },

    grantModulePermissions: (moduleName) => {
      if (role?.role === "superadmin") return true;

      return permissions?.[moduleName] && permissions[moduleName]?.length > 0;
    },
  };

  return functions;
}
